import {
  DOC_TYPE_K1_PACKAGE,
  DOC_TYPE_FILED_COPIES,
  K1_PACKAGE_PURPOSE_TAB,
  FILED_COPIES_PURPOSE_TAB,
} from "./moveDocumentScope";

export const DOCUMENTS_HOME_NAV = [{ id: 0, name: "Home", created_by: 0 }];

export function isDocumentsHomePath(navPath) {
  return (
    Array.isArray(navPath) &&
    navPath.length === 1 &&
    Number(navPath[0]?.id) === 0
  );
}

/**
 * Map folder_type to the documents sub-tab when the user opens a folder.
 * @param {boolean} autoSwitchSentReceived — client portal + client details staff view
 */
export function resolveActiveTabFromFolderType(
  folderType,
  { isClient, docCategory, autoSwitchSentReceived = false } = {},
) {
  const ft = String(folderType || "").toLowerCase();
  if (!ft || ft === "home") return null;

  if (ft === DOC_TYPE_K1_PACKAGE) {
    return K1_PACKAGE_PURPOSE_TAB;
  }

  if (ft === DOC_TYPE_FILED_COPIES) {
    return FILED_COPIES_PURPOSE_TAB;
  }

  if (ft === "office") {
    if (isClient) return "sent";
    return "office";
  }

  if (autoSwitchSentReceived || isClient) {
    if (ft === "client") return isClient ? "sent" : "received";
    if (ft === "emp") return isClient ? "received" : "sent";
  }

  return null;
}

/** Resolve folder_type for the current nav segment (Home => "home"). */
export function resolveFolderTypeFromNav(
  navPath,
  homeFolders = [],
  homeFolderName = "",
) {
  const currentPath = navPath?.[navPath.length - 1];
  if (!currentPath) return "";

  if (Number(currentPath.id) === 0) return "home";

  if (currentPath.folder_type) return currentPath.folder_type;

  const folderData = (homeFolders || []).find(
    (data) => data.client_folder_id === currentPath.id,
  );
  if (folderData?.folder_type) return folderData.folder_type;

  if (currentPath.name === homeFolderName) return "home";
  return "";
}
